import RequestAbstract from "./RequestAbstract";

export default class Images extends RequestAbstract {
    get link() {
        return this.links.images;
    }

    // 1 - small, 0 - original
    getAvatar(id, size = 1) {
        return this.getFullLink(this.link + "/" + id + "/" + size);
    }

    async downloadImg(imageUrl, imageName) {
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = imageName;
        link.click();
        URL.revokeObjectURL(blobUrl);
    }

    uploadAvatar(uid, info) {
        //return new Promise((resolve, reject) => {
        this.postFormData(this.link + `/client/${uid}/upload/`, info, (error, result) => {
            if (error) {
                //reject(error);
                console.log(error);
            } else {
                //resolve(result);
                console.log(result);
            }
        });
        //});
    }

    uploadEmployeeAvatar(uid, info, cb) {
        //return new Promise((resolve, reject) => {
        this.postFormData(this.link + `/employee/${uid}/upload`, info, cb);
        //});
    }

}
